import {ValueObject} from '@s-ui/domain'

export class UserDiscardedAdsListValueObject extends ValueObject {
  #items

  static create({items}) {
    return new UserDiscardedAdsListValueObject({items})
  }

  /**
   * @constructor
   * @param {Object} data
   * @param {Array} data.items
   * */
  constructor({items}) {
    super()
    this.#items = items
  }

  toJSON() {
    return {
      items: this.#items
    }
  }
}
